import React, { useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import { IoChevronBackSharp, IoChevronForwardSharp } from 'react-icons/io5';
import Navbar from '../../navbar';
import Header from '../../header';
import { fetchApplicationWithId, updateApplication } from '../../../store/reducers/applicationSlice';
import classes from './style.module.css';
import { getstate } from '../../../store/reducers/stateSlice';
import { fetchCategories } from '../../../store/reducers/categoriesSlice';
import { getNotificationTemplate } from '../../../utility/notificationTemplates';
import { createNotification } from '../../../store/reducers/notificationSlice';
import { setFormFieldData, hideAllPagesExceptCurrentFormPage, goToFormNextPage, goToFormPreviousPage, setPage } from '../../../utility/utility';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-datepicker/dist/react-datepicker.css';
import { getSignature } from '../../../store/reducers/fileSlice';
import FormLoader from '../../forms/formLoader';
import RejectDialog from "./rejectDialog/rejectDialog";
import StatusConfirmDialog, {
  STATUS_LABELS,
  getStatusRoute,
} from "./statusConfirmDialog/statusConfirmDialog";
import AuditTrailModal from "./auditTrail/AuditTrailModal";
import {
  formatLifecycleDate,
  getApprovalDate,
  getRejectionDate,
  getSubmissionDate,
} from "../../../utility/lifecycleDates";

const ViewApp = () => {
    const dispatch = useDispatch();
    const params = useParams();
    const user = useSelector((state) => state.auth.user);
    const authToken = user?.access_token;
    const { currentApp, fetchLoading } = useSelector((state) => state.applications);
    const accessToken = user?.access_token;
    const [formData, setFormData] = useState([]);
    const applicationdata = useSelector((state) => state.applications.currentApp);
    const status = useSelector((state) => state.status.status);
    const [modalIsOpen, setIsOpen] = React.useState(false);
    const [formIds, setFormIds] = useState([]);
    const [pageIds, setPageIds] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [isLoaded, setIsLoaded] = useState(false);
    const [expiryDate, setExpiryDate] = useState(new Date());
    const [signatureImage, setSignatureImage] = useState('');
    const [inputPage, setInputPage] = useState(currentPage);
    const [isDataPopulated, setIsDataPopulated] = useState(false);
    const navigate = useNavigate();
    const [showRejectModal, setShowRejectModal] = useState(false);
    const [rejectReason, setRejectReason] = useState("");
    const [selectedRejectItem, setSelectedRejectItem] = useState(null);
    const [showStatusModal, setShowStatusModal] = useState(false);
    const [pendingStatusName, setPendingStatusName] = useState(null);
    const [showAuditTrail, setShowAuditTrail] = useState(false);

    useEffect(() => {
        setInputPage(currentPage); // keep input in sync when prop changes
    }, [currentPage]);

    const handleChange = (date) => {
        setExpiryDate(date); // Update the date in the parent component
    };

    const handleOpenReject = (item) => {
        setSelectedRejectItem(item);
        setRejectReason("");
        setShowRejectModal(true);
    };

    const handleCloseReject = () => {
        setShowRejectModal(false);
        setSelectedRejectItem(null);
        setRejectReason("");
    };

    const requestStatusChange = (statusName) => {
        setPendingStatusName(statusName);
        setShowStatusModal(true);
    };

    const handleCloseStatusModal = () => {
        setShowStatusModal(false);
        setPendingStatusName(null);
    };

    const handleConfirmStatusChange = () => {
        const statusName = pendingStatusName;
        handleCloseStatusModal();
        if (statusName) {
            applySelectedStatus(statusName);
        }
    };

    const handleConfirmReject = () => {
        const updatedItem = { ...selectedRejectItem };
        const discrepancies =
            selectedRejectItem.discrepancies && typeof selectedRejectItem.discrepancies === "object"
                ? { ...selectedRejectItem.discrepancies }
                : {};
        discrepancies.other = { value: rejectReason, check: true };
        updatedItem.discrepancies = discrepancies;

        setShowRejectModal(false);
        handleChangeStatus(updatedItem, 5, discrepancies);
    };

    const handleChangeStatus = async (item, state, discrepancies = null) => {
        await dispatch(
            updateApplication({
                id: item?.id,
                state: state,
                descripencie: item.discrepancies,
                json_data: item?.json_data,
                remarks: discrepancies?.other?.value || item?.remarks || undefined,
                accessToken: accessToken,
            })
        ).then(() => {
            const template = getNotificationTemplate('rejected', {
                ...item,
                userName: item.userName || item.user_name || 'User',
                discrepancies: discrepancies
            });

            dispatch(createNotification({
                message: template.message,
                subject: template.subject,
                htmlMailContent: template.html,
                sendToCompanyAdmins: true,
                userId: item.userId || item.user_id,
                accessToken: authToken,
                is_admin: false
            }));
            navigate(`/rejected-applications`);
        });
    };

    const statusvalue = useCallback(async () => {
        if (!params.id || !accessToken) return;
        const data = {
            accessToken: accessToken,
            id: params.id,
        };
        dispatch(fetchApplicationWithId(data));
        dispatch(getstate(accessToken));
        dispatch(fetchCategories({ accessToken: accessToken }))
    }, [params.id, accessToken, dispatch]);

    const selecteddata = (e) => {
        if (e === "rejected") {
            handleOpenReject(applicationdata);
            return;
        }
        requestStatusChange(e);
    };

    const applySelectedStatus = async (e) => {
        const filterstatus = status.filter((item) => item.name === e);
        let dueDate = null;
        if (e === 'approved') {
            setIsOpen(true);
            const currentDateTime = new Date();
            dueDate = currentDateTime.toISOString().split('T')[0];
        }

        await dispatch(
            updateApplication({
                accessToken,
                id: params.id,
                state: filterstatus ? filterstatus[0].id : '',
                dueDate,
                json_data: applicationdata?.json_data,
            })
        );
        const template = getNotificationTemplate(e, {
            ...applicationdata,
            userName: applicationdata.userName || applicationdata.user_name || 'User',
            discrepancies: applicationdata.descripencie
        });

        dispatch(createNotification({
            message: template.message,
            subject: template.subject,
            htmlMailContent: template.html,
            sendToCompanyAdmins: true,
            userId: applicationdata.userId || applicationdata.user_id,
            accessToken: authToken,
            is_admin: false
        }))
        if (e === "descrepency_GB_GB") {
            navigate(`/descrip-applications/${params.id}`);
            return;
        }
        const destination = getStatusRoute(e) || getStatusRoute(filterstatus?.[0]?.id);
        if (destination) {
            navigate(destination);
        } else {
            statusvalue();
        }
    };

    useEffect(() => {
        if (params.id && accessToken) {
            setIsLoaded(false); // Reset loaded state when application ID changes
            setIsDataPopulated(false); // Reset data population state
            setFormData([]); // Reset form data
            setFormIds([]); // Reset form IDs
            setPageIds([]); // Reset page IDs
            setCurrentPage(1); // Reset to first page
            setSignatureImage(''); // Reset signature
            statusvalue();
        }
    }, [params.id, accessToken, statusvalue]);

    useEffect(() => {
    }, [expiryDate])

    useEffect(() => {
        const runAsyncFunctions = async () => {
            if (isLoaded && applicationdata) {
                if (applicationdata.json_data) {
                    await setFormFieldData(applicationdata.json_data);
                }
                let userId = applicationdata.user_id
                if (userId) {
                    try {
                        let signature = await getSignature({ userId: userId, applicationId: params.id, authToken });
                        setSignatureImage(signature);
                    } catch (err) {
                        console.error('Error fetching signature:', err);
                    }
                }
                setIsDataPopulated(true);
            }
        };

        runAsyncFunctions();
    }, [isLoaded, applicationdata, params.id, authToken]);

    useEffect(() => {
        if (pageIds && pageIds.length > 0) {
            hideAllPagesExceptCurrentFormPage(pageIds, currentPage);
        }
    }, [pageIds, currentPage])

    useEffect(() => {
        if (formIds && signatureImage && isLoaded) {
            formIds.forEach(id => {
                const inputField = document.getElementById(id);
                if (inputField.type === 'image') {
                    inputField.src = signatureImage;
                }
            });

        }
    }, [signatureImage, isLoaded, formIds])

    return (
        <div>
            <Navbar />
            <Header />
            <div className="wrapper">
                <div className="boxAppBoard boxWhite">
                    <div className="stickyFormHeader">

                        <div className="AppFormBar noShadow">
                            <div className="title">
                                {currentApp?.name}  {formData.find((el) => el.id === currentPage)?.pageName}
                            </div>
                            <div className='pagination'>
                                <div className='pageNum d-flex align-items-center'>
                                    <IoChevronBackSharp onClick={() => goToFormPreviousPage(currentPage, setCurrentPage)} />
                                    
                                    <input
                                        type="number"
                                        value={inputPage}
                                        style={{
                                            width: '50px',
                                            padding: '0px',
                                            background: '#191b1c',
                                            color: 'white',
                                            borderRadius: '5px',
                                            textAlign: 'center',
                                            appearance: 'none',
                                            borderWidth: 'medium',
                                            borderStyle: 'none',
                                            borderColor: 'currentcolor',
                                            borderImage: 'none',
                                        }}
                                        min="1"
                                        max={Number(pageIds.length)}
                                        onBeforeInput={(e) => {
                                            if (!/^\d$/.test(e.data)) {
                                                e.preventDefault(); // Only allow digit input
                                            }
                                        }}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            setInputPage(value); // update local state for controlled input
                                            if (value !== '') {
                                                const pageNum = parseInt(value);
                                                if (!isNaN(pageNum)) {
                                                    setPage(pageNum, currentPage, pageIds, setCurrentPage);
                                                }
                                            }
                                        }}
                                        onFocus={(e) => e.target.select()}
                                        onMouseUp={(e) => e.preventDefault()}
                                    />

                                    <span className='slash'>{`/`}<span style={{ marginLeft: 10 }}>{pageIds.length}</span></span>
                                    <IoChevronForwardSharp onClick={() => goToFormNextPage(currentPage, pageIds, setCurrentPage)} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="boardHeader">
                        <div className="boardHeadLeft">
                            <h2>In Process Applications</h2>
                            <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap', marginTop: '8px', fontSize: '13px', color: '#425466' }}>
                                <span>Submitted: {formatLifecycleDate(getSubmissionDate(applicationdata))}</span>
                                <span>Approved: {formatLifecycleDate(getApprovalDate(applicationdata))}</span>
                                <span>Rejected: {formatLifecycleDate(getRejectionDate(applicationdata))}</span>
                            </div>
                        </div>
                        <div className="boardHeadRight">
                            <button
                                type="button"
                                className="btn btn-outline-primary me-2"
                                onClick={() => setShowAuditTrail(true)}
                                style={{ height: '38px', whiteSpace: 'nowrap' }}
                            >
                                Audit Trail
                            </button>
                            <div>
                                <select
                                    className="form-select"
                                    value={applicationdata?.state || 'All'}
                                    onChange={(e) => {
                                        selecteddata(e.target.value);
                                    }}
                                >
                                    <option disabled value="All">
                                        Select State
                                    </option>
                                    {status.length > 0 &&
                                        status.map((item) => {
                                            const displayText =
                                                item.name === 'in_process' ? 'In Process' :
                                                    item.name === 'descrepency_GB_GB' ? 'Discrepancies' :
                                                        item.name === 'approved' ? 'Approved' :
                                                            item.name === 'rejected' ? 'Rejected' :
                                                                null; // Use null for unmatched cases

                                            return displayText ? (
                                                <option key={item.name} value={item.name}>
                                                    {displayText}
                                                </option>
                                            ) : null; // Return null for unmatched cases
                                        })
                                    }
                                </select>
                            </div>

                        </div>
                    </div>

                    <div className={classes['board-content']}>
                        {(fetchLoading || !currentApp?.id || !isLoaded || !isDataPopulated) && (
                            <div className="d-flex justify-content-center align-items-center" style={{ height: "400px" }}>
                                <div className="spinner-border text-primary" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </div>
                        )}
                        {!fetchLoading && currentApp?.id && (
                            <div style={{ display: (isLoaded && isDataPopulated) ? 'block' : 'none' }}>
                                <FormLoader
                                    key={params.id || applicationdata?.id || 'default'} // Force remount when application changes
                                    applicationName={applicationdata?.name || ""}
                                    setFormIds={setFormIds}
                                    setPageIds={setPageIds}
                                    setIsLoaded={setIsLoaded}
                                />
                            </div>
                        )}
                    </div>

                    <RejectDialog
                        open={showRejectModal}
                        reason={rejectReason}
                        setReason={setRejectReason}
                        onReject={handleConfirmReject}
                        onCancel={handleCloseReject}
                    />

                    <StatusConfirmDialog
                        open={showStatusModal}
                        title="Are you sure you want to change status?"
                        message={
                            pendingStatusName
                                ? `Change status to "${STATUS_LABELS[pendingStatusName] || pendingStatusName}"?`
                                : ""
                        }
                        onConfirm={handleConfirmStatusChange}
                        onCancel={handleCloseStatusModal}
                    />

                    <AuditTrailModal
                        open={showAuditTrail}
                        onClose={() => setShowAuditTrail(false)}
                        applicationId={params.id}
                        accessToken={accessToken}
                    />
                </div>
            </div>

        </div>
    );
};

export default ViewApp;
